import { DashboardCard } from "../../dashboard-card";

export function EventsContent() {
  const mockEvents = [
    {
      id: 1,
      title: "Patient Consultation",
      eventDate: new Date(),
      eventTime: "2:30 PM - 3:00 PM",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Dr. Smith",
          name: "Dr. Sarah Smith",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Patient",
          name: "Maria Rodriguez",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Nurse",
          name: "Jennifer Wilson",
        },
      ],
      eventActions: {
        onCancel: () => console.log("Event 1 cancelled"),
        onNoShow: () => console.log("Event 1 marked as no show"),
        onComplete: () => console.log("Event 1 completed"),
      },
    },
    {
      id: 2,
      title: "Follow-up Appointment",
      eventDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // Tomorrow
      eventTime: "10:00 AM - 10:30 AM",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Dr. Wilson",
          name: "Dr. Michael Wilson",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Patient",
          name: "Maria Rodriguez",
        },
      ],
      eventActions: {
        onCancel: () => console.log("Event 2 cancelled"),
        onNoShow: () => console.log("Event 2 marked as no show"),
        onComplete: () => console.log("Event 2 completed"),
      },
    },
    {
      id: 3,
      title: "Lab Results Review",
      eventDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000), // 3 days from now
      eventTime: "4:15 PM - 4:45 PM",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Dr. Smith",
          name: "Dr. Sarah Smith",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Lab Tech",
          name: "Alex Johnson",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Patient",
          name: "Maria Rodriguez",
        },
      ],
      eventActions: {
        onCancel: () => console.log("Event 3 cancelled"),
        onNoShow: () => console.log("Event 3 marked as no show"),
        onComplete: () => console.log("Event 3 completed"),
      },
    },
    {
      id: 4,
      title: "Specialist Referral",
      eventDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 1 week from now
      eventTime: "1:00 PM - 2:00 PM",
      assignees: [
        {
          src: "https://github.com/shadcn.png",
          alt: "Specialist",
          name: "Dr. Emily Chen",
        },
        {
          src: "https://github.com/shadcn.png",
          alt: "Patient",
          name: "Maria Rodriguez",
        },
      ],
      eventActions: {
        onCancel: () => console.log("Event 4 cancelled"),
        onNoShow: () => console.log("Event 4 marked as no show"),
        onComplete: () => console.log("Event 4 completed"),
      },
    },
  ];

  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {mockEvents.map((event) => (
        <DashboardCard
          key={event.id}
          variant="event"
          title={event.title}
          eventDate={event.eventDate}
          eventTime={event.eventTime}
          assignees={event.assignees}
          eventActions={event.eventActions}
          className="w-full"
        />
      ))}
    </div>
  );
}
